<div>
  <submission-loading v-if="!isAllReadyStatesComplete()" :id="$vId(this)" />

  <div v-show="isAllReadyStatesComplete()" v-if="submission.status === 'live'" class="mt-block">
    <div class="mt-wrapper">
      <fou-container :id="$vId(this, 'correct-form')" cols="12" background padded>
        <template #header>
          <h5 class="mt-h5">{{$t('pages.submissions.correct.title')}} {{submissionFamilyName}}.</h5>
        </template>
        <template #content>
          <v-grid>
            <v-row class="mt-group">
              <v-col has="10" off="1">
                <fou-accordion :class="$style.accordion">
                  <fou-modal v-if="isUpdateModal" visible ref="updateModal" :id="$vId(this, 'live-edit')"
                    :class="$style.modal" cols="8">
                    <template #content>
                      <div :class="$style.slotUpdateContent">
                        <submission-loading updateModal :cancelling="canceledModal" v-if="isAnimating"
                          :id="$vId(this, 'live-edit-loader')" />
                        <div v-else>
                          <h3 class="mt-h3" :class="[$style.modalTitle, $style.modalTextColor]">
                            {{$t('pages.submissions.components.menue.live_modal_update.title')}}
                          </h3>
                          <fou-group bottom="medium">
                            <div :class="[$style.left, $style.modalTextColor, $style.fs14]">
                              <p :class="$style.noteText">
                                {{$t('pages.submissions.components.menue.live_modal_update.text1')}}
                              </p>
                              <p :class="$style.noteText"
                                v-html="$t('pages.submissions.components.menue.live_modal_update.text2')"></p>
                            </div>
                          </fou-group>

                          <fou-group>
                            <div :class="$style.malwareTextMainDiv">
                              <span :class="getScanStatus === '' ? $style.scanningMalwareIcon : getScanStatus === true ? $style.successMalwareIcon : $style.malwareIcon"></span>
                              <span :class="$style.malwareText">
                                {{
                                  getScanStatus === ''
                                    ? $t('malwareScan.scanInitiationMessage')
                                    : getScanStatus === true
                                    ? $t('malwareScan.scanCompletionMessage')
                                    : $t('malwareScan.malwareDetectionMessage')
                                }}
                              </span>
                            </div>
                          </fou-group>

                          <div class="row mt-list-item" :class="[$style.padLHeading32, $style.fontFamilyKoot]">
                            <div class="is6" :class="[$style.fs10]">
                              {{$t('pages.submissions.components.menue.live_modal_update.div_head1')}}
                            </div>
                            <div class="is6" :class="[$style.fs10, $style.padL8]">
                              {{$t('pages.submissions.components.menue.live_modal_update.div_head2')}}
                            </div>
                          </div>
                          <div ref="updateModalScrollArea" @scroll="validateScrollError($event)"
                            :id="$vId(this, 'live-submissions')"
                            :class="[$style.padLR19, $style.updateModal]">
                            <ul class="mt-list" v-if="filteredUpdateModalData.length > 0">
                              <li v-for="item, key in filteredUpdateModalData" class="row mt-list-item" :key="key"
                                :class="[$style.liVCenter, $style.btmBorder1]">
                                <div v-tooltip="{content: item.newBinary.psName, placement: 'bottom'}" class="is6">
                                  <span v-if="item.newBinary.psName === 'n/a' || item.newBinary.styleName === ''"
                                    :class="$style.loading">
                                    <load-animation></load-animation>
                                  </span>
                                  <div v-else :class="[$style.wrapElipses]" class="mt-serif mt-serif--size5">
                                    {{item.newBinary.psName}}
                                  </div>
                                </div>
                                <div class="is6">
                                  <div class="out-right" :class="[$style.offLeft]">
                                    <span v-if="item.newBinary.psName === 'n/a' || item.newBinary.styleName === ''"
                                      :class="[$style.loading, $style.loadingWidth]">
                                      <load-animation></load-animation>
                                    </span>
                                    <select v-else v-model="selectedLabels[key]" @change="selectFont()"
                                      :class="[selectedLabels[key]==='select' ? $style.gray : $style.black, $style.updateSelect, $style.selectTextSpacing]">
                                      <option v-for="itemList, index in (item.releasedBinaries)" :key="index"
                                        :value="itemList.binaryId">
                                        {{itemList.psName}}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div>
                            <ul class="mt-list" :class="$style.mT10">
                              <li v-for="err in modalErrors" class="mt-list-item mt-error mt-error--padded mt-line">
                                <p class="mt-line">{{err.msg}}</p>
                              </li>
                              <li v-if="getFilesWithFalseAvStatus.length > 0" :class="['mt-list-item', 'mt-line', $style.malwareErrorMsz]">
                                <p class="mt-line">
                                  <span v-html="$t('pages.submissions.components.menue.live_modal_update.error.id6')"></span>
                                  <a href='mailto:foundrysupport@monotype.com' class='malwareErrrorMessage' @click='redirectMethod()'>
                                    {{ $t('pages.submissions.components.menue.live_modal_update.foundry_support_mail') }}
                                  </a>.
                                  <p v-for="(item, index) in getFilesWithFalseAvStatus" :key="index">
                                    • {{item}}
                                  </p>
                                </p>
                              </li>
                            </ul>
                          </div>
                          <fou-group class="mt-flex mt-flex--between">
                            <button type="button" @click="resetPage" class="mt-button mt-button--inverted"
                              :class="$style.updateModalControls" :disabled="getLiveModalCancelButton">
                              {{$t('pages.submissions.components.menue.live_modal_update.cancel')}}
                            </button>
                            <button 
                              type="button" 
                              @click="updateLiveSubmission" 
                              :disabled="hasAllPSNames || getFilesWithFalseAvStatus.length > 0 || filteredUpdateModalData.length <= 0"
                              class="mt-button" :class="$style.updateModalControls"
                            >
                              {{$t('pages.submissions.components.menue.live_modal_update.upload')}}
                            </button>
                          </fou-group>
                        </div>
                      </div>
                    </template>
                  </fou-modal>
                  <fou-accordion-item open :id="$vId(this, 'upload-section')"
                    :class="accordionItemClassForUploadSection">
                    <template #heading>
                      <div :class="[$style.headingUpload, $style.heading]">
                        <h2 class="mt-h2" :class="$style.title">
                          {{$t('pages.submissions.components.upload.live_heading')}}
                        </h2>
                      </div>
                    </template>
                    <template #content>
                      <upload :id="$vId(this)" :class="$style.accordionContent"> </upload>
                    </template>
                  </fou-accordion-item>

                  <fou-accordion-item :id="$vId(this, 'prices-section')" :class="accordionItemClassForPriceSection">
                    <template #heading>
                      <div :class="[$style.headingPrices, $style.heading]">
                        <h2 class="mt-h2" :class="$style.title">
                          {{$t('pages.submissions.components.prices.heading')}}
                        </h2>
                      </div>
                    </template>
                    <template #content>
                      <prices :id="$vId(this)" :class="$style.accordionContent"> </prices>
                    </template>
                  </fou-accordion-item>

                  <fou-accordion-item :id="$vId(this, 'descriptions-section')"
                    :class="accordionItemClassForDescriptionSection">
                    <template #heading>
                      <div :class="[$style.headingDesc, $style.heading]">
                        <h2 class="mt-h2" :class="$style.title">
                          {{$t('pages.submissions.components.descriptions.heading')}}
                        </h2>
                      </div>
                    </template>
                    <template #content>
                      <descriptions :id="$vId(this)" :class="$style.accordionContent"> </descriptions>
                    </template>
                  </fou-accordion-item>

                  <fou-accordion-item :id="$vId(this, 'descriptions-section')"
                    :class="accordionItemClassForGraphicsSection">
                    <template #heading>
                      <div :class="[$style.headingImages, $style.heading]">
                        <h2 class="mt-h2" :class="$style.title">
                          {{$t('pages.submissions.components.graphics.heading')}}
                        </h2>
                      </div>
                    </template>
                    <template #content>
                      <graphics :id="$vId(this)"></graphics>
                    </template>
                  </fou-accordion-item>
                </fou-accordion>
              </v-col>
            </v-row>
            <!-- # steps end -->
          </v-grid>
        </template>
      </fou-container>
      <channels :foundryId="submissionFoundryId" v-if="externalDataSource && !hasRole(['foundrySupport'])"></channels>
      <fou-container :id="$vId(this, 'correct-submit-form')" cols="12" background padded
        :class="$style.descriptionEdit">
        <template #header>
          <div>
            <h5 class="mt-h5" v-html="$t('pages.submissions.correct.description_live')"></h5>
          </div>
        </template>
        <template #content>
          <v-grid>
            <v-row>
              <v-col has="10" off="1">
                <section class="mt-section">
                  <p class="mt-serif mt-serif--size4" v-html="$t('pages.submissions.correct.description_live_s')"></p>
                  <div :class="$style.descriptionLiveNotes">
                    <p :class="$style.mT20" class="mt-serif mt-serif--bold mt-serif--size3"
                      v-html="$t('pages.submissions.correct.description_live_notes')"></p>
                    <p>
                      {{$t('pages.submissions.correct.description_live_notes_optional')}}
                    </p>
                    </div>
                  <p :class="$style.mB20" class="mt-serif mt-serif--size4"
                    v-html="$t('pages.submissions.correct.description_live_notes_s')"></p>
                  <FouTextArea :id="$vId(this, 'support-note')" name="support note"
                    :input-class="['mt-textarea mt-line', {'mt-input--error': Object.hasOwn(errors, 'support note')}]"
                    v-model="description" maxlength="5000" rows="9" rules="max:5000||script_tag_validate"
                    :placeholder="$t('pages.submissions.components.confirmation.type_here')"></FouTextArea>
                </section>
              </v-col>
            </v-row>
            <!-- validation -->
            <v-row :class="$style.submit">
              <v-col has="10" off="1" class="row">
                <fou-modal :id="$vId(this, 'live-edit')" :class="$style.modal" cols="8">
                  <template #trigger>
                    <button :id="$vId(this, 'cancel')" type="button" class="mt-button mt-button--inverted"
                      :class="$style.mRT10">
                      {{$t('pages.submissions.components.menue.live_modal.trigger')}}
                    </button>
                  </template>
                  <template #content>
                    <div :class="$style.slotContent">
                      <h3 class="mt-h3" :class="[$style.modalTitle, $style.modalTextColor]">
                        {{$t('pages.submissions.components.menue.live_modal.title')}}
                      </h3>
                      <fou-group bottom="medium">
                        <div :class="[$style.left, $style.modalTextColor]">
                          <p :class="$style.noteText">{{$t('pages.submissions.components.menue.live_modal.text1')}}</p>
                        </div>
                      </fou-group>
                      <fou-group class="mt-flex mt-flex--between" :class="$style.modalControls">
                        <button type="button" @click="hide" :class="$style.modalControlsItem"
                          class="mt-button mt-button--inverted">
                          {{$t('pages.submissions.components.menue.live_modal.go_back')}}
                        </button>
                        <button type="button" class="mt-button" :class="$style.modalControlsItem" @click="exit">
                          {{$t('pages.submissions.components.menue.live_modal.exit')}}
                        </button>
                      </fou-group>
                    </div>
                  </template>
                </fou-modal>
                <div>
                  <button :id="$vId(this, 'submit')" type="button" @click="validateSubmission" class="mt-button">
                   {{$t('pages.submissions.correct.action.submit')}}
                  </button>
                </div>
                <fou-modal v-if="submitClicked" visible ref="submitModal" :id="$vId(this, 'live-edit-submit')"
                  :class="$style.modal" cols="8">
                  <template #content>
                    <div :class="$style.slotContent">
                      <h3 class="mt-h3" :class="[$style.modalTitle, $style.modalTextColor]">
                        {{$t('pages.submissions.components.menue.live_modal_submit.title')}}
                      </h3>
                      <fou-group bottom="medium">
                        <div :class="[$style.left, $style.modalTextColor]">
                          <p v-html="$sanitize($t('pages.submissions.components.menue.live_modal_submit.text1'))"></p>
                          <p v-html="$sanitize($t('pages.submissions.components.menue.live_modal_submit.text2'))"></p>
                        </div>
                      </fou-group>
                      <fou-group class="mt-flex mt-flex--between" :class="$style.modalControls">
                        <button type="button" @click="hide" class="mt-button mt-button--inverted"
                          :disabled="isSubmitting" :class="$style.modalControlsItem">
                          {{$t('pages.submissions.components.menue.live_modal_submit.cancel_live')}}
                        </button>
                        <button type="button" @click="submitLiveCorrection" class="mt-button" :disabled="isSubmitting"
                          :class="$style.modalControlsItem">
                          {{$t('pages.submissions.components.menue.live_modal_submit.submit_live')}}
                        </button>
                      </fou-group>
                    </div>
                  </template>
                </fou-modal>
              </v-col>
              <v-col has="10" off="1" class="row">
                <div :class="$style.supportSubmitButton" v-if="stepsErrors.length || requiredErrorsOnly || getImagesWithMalware.length>0">
                  <fou-group class="mt-error">
                    {{$tc('pages.submissions.index.errors_correction', stepsErrors.length, {count:
                    stepsErrors.length})}}:
                  </fou-group>
                  <ul class="mt-list">
                    <li v-if="requiredErrorsOnly" class="mt-list-item mt-error mt-error--padded mt-line">
                      <p class="mt-line">{{requiredErrorsOnly}}</p>
                    </li>
                    <li v-for="step in stepsErrors" class="mt-list-item mt-error mt-error--padded mt-line">
                      <p class="mt-line" v-for="err in step" v-html="$sanitize(err)"></p>
                    </li>
                    <li v-if="getImagesWithMalware.length > 0" :class="['mt-list-item', 'mt-error', 'mt-error--padded', 'mt-line', $style.malwareErrorMsz, $style.marginTopforError]">
                      <p class="mt-line">
                        <p v-html="$t('malwareScan.imageErrorMessageNew')"></p>
                        <p v-for="(item, index) in getImagesWithMalware" :key="index">
                          • {{item.fileName}}
                        </p>
                      </p>
                    </li>
                  </ul>
                </div>
                <div :class="$style.supportSubmitButton" v-if="uniqueStyleErrors.length > 0">
                  <ul class="mt-list">
                    <li v-for="uniqError in removeDuplicates(uniqueStyleErrors, true)"
                      class="mt-list-item mt-error mt-error--padded mt-line">
                      <p class="mt-line"
                        v-html="$t('pages.submissions.index.live_unique_style_error', {styleName : uniqError.styleName})">
                      </p>
                    </li>
                  </ul>
                </div>
              </v-col>
            </v-row>
            <!-- validation end -->
          </v-grid>
        </template>
      </fou-container>
    </div>
  </div>
</div>
